(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("semanticForms", [], factory);
	else if(typeof exports === 'object')
		exports["semanticForms"] = factory();
	else
		root["semanticForms"] = factory();
})(this, () => {
return 